<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
          <Dialogs  header="Product"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">

              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Name <span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="name" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="itemCode" >Code<span style="color:red">*</span></label>
                <InputText id="itemCode" v-model.trim="itemCode" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="unit" >Unit<span style="color:red">*</span></label>
                <InputText id="unit" v-model.trim="unit" />
              </div>
              
              <div class="p-field p-col-12 p-md-6">
                <label for="marketpurchaseprice" >Market Purchase Rate</label>
                <InputText @keypress="isNumber($event)" v-model="marketpurchaseprice" id="marketpurchaseprice"/>
              </div>

               <div class="p-field p-col-12 p-md-6">
                <label for="marketSellingPrice" >Market Sales Rate</label>
                <InputText @keypress="isNumber($event)" v-model="marketSellingPrice" id="marketSellingPrice"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="sellingPrice" >Sales Rate</label>
                <InputText v-model.trim="sellingprice" id="sellingPrice" />
              </div>

              

              <div class="p-field p-col-12 p-md-6">
                <label for="commissionrate" >Commission Rate</label>
                <InputText v-model.trim="commissionrate" id="commissionrate" />
              </div>

             <div class="p-field p-col-12 p-md-6">
              <label for="discountRate" >Discount</label>
              <InputText v-model.trim="discountRate" id="discountRate"/>
            </div>

            <div class="p-field p-col-12 p-md-6">
                <label for="startDate" >Sales Started Date</label>
                <InputMask mask="9999-99-99" type="text" id="startDate" v-model="startDate"/>
              </div>

             <div class="p-field p-col-12 p-md-6">
                <label for="status1" >Status</label>
                <div class="p-field p-col-12 p-md-6">
                  <RadioButton id="status1" name="ACTIVE" value="ACTIVE" v-model="status" />
                  <label for="status1">Active</label>
                  <RadioButton id="status2" name="INACTIVE" value="INACTIVE" v-model="status" />
                  <label for="status2">Inactive</label>
                </div>
              </div>
            <div class="p-field p-col-12 p-md-6">
                <label for="description">Description</label>
                <Textarea id="description" rows="3" class="form-control" v-model="description"/>
              </div>

      </div>
      <template #footer>
        <Button class="p-button-raised p-button" @click.prevent="addProduct" :label="editing?'Update':'Add'"/>
        <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewProduct" v-if="!editing"/>
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Textarea from 'primevue/textarea/Textarea'
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
export default {
  name: 'supplier',
  data() {
    return {
      name: '',
      itemCode: '',
      unit: '',
      startDate: '',
      sellingprice: 0,
      discountRate: 0,
      commissionrate: 0,
      marketSellingPrice: 0,
      marketpurchaseprice: 0,
      description: '',
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      status: 'ACTIVE',
      id: '',
      loading: false,
      columnList: '',
      filters: {}
    }
  },
  methods: {
    async addProduct() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        id: this.id,
        itemCode: this.itemCode,
        name: this.name,
        unit: this.unit,
        startDate: this.startDate,
        sellingPrice: this.sellingprice,
        discountRate: this.discountRate,
        status: this.status,
        commissionRate: this.commissionrate,
        marketSellingPrice: this.marketSellingPrice,
        marketPurchasePrice: this.marketpurchaseprice,
        description: this.description
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCrmProduct', accountMaster)
        // this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCrmProduct', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewProduct() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        itemCode: this.itemCode,
        name: this.name,
        unit: this.unit,
        startDate: this.startDate,
        sellingPrice: this.sellingprice,
        discountRate: this.discountRate,
        status: this.status,
        commissionRate: this.commissionrate,
        marketSellingPrice: this.marketSellingPrice,
        marketPurchasePrice: this.marketpurchaseprice,
        description: this.description
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCrmProduct', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    editCrmProduct(data) {
      this.addDialog = true
      this.id = data.id
      this.editing = true
      this.itemCode = data.itemCode
      this.name = data.name
      this.unit = data.unit
      this.sellingprice = data.sellingPrice
      this.marketpurchaseprice = data.marketPurchasePrice
      this.discountRate = data.discountRate
      this.status = data.status
      this.commissionrate = data.commissionRate
      this.marketSellingPrice = data.marketSellingPrice
      this.description = data.description
      this.startDate = data.startDate
      this.openAddDialog()
    },
    reset() {
      this.name = ''
      this.startDate = ''
      this.sellingprice = 0
      this.discountRate = 0
      this.status = 'ACTIVE'
      this.commissionrate = 0
      this.marketSellingPrice = 0
      this.marketpurchaseprice = 0
      this.description = ''
      this.licenseExpireDate = ''
      this.unit = ''
      this.itemCode = ''
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
      this.reset()
    },
    addCancel() {
      this.reset()
      this.closeAddDialog()
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// crmProductDetailsDialog.vue?4e76056c